<template>
    <div>
        <div class="l79vjd40">
            <ul class="l5lt9c0o">
                <li
                    v-for="(v,k) in list"
                    :key="k"
                    class="l5ixubw6"
                    :class="[
                    {
                        active: activeIndex === k,
                    }
                ]"
                    @click="handleClick(k)"
                >
                    {{ v.label }}
                </li>
            </ul>
            <slot name="right"></slot>
        </div>
        <div
            v-for="(v,k) in list"
            :key="k"
            v-show="activeIndex === k"
            class="l5szz1m4"
        >
            <div v-if="activeIndex === k || createdItem.includes(k)">
                <slot
                    :name="v.value"
                    v-bind="{v, k}"
                >
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ViewsDetailComponentsTabs",
    props: {
        list: {
            type: Array,
            required: true,
        },
        activeIndexProp: {
            type: Number,
            default: () => 0,
        },
    },
    data() {
        return {
            activeIndex: 0,
            createdItem: [],
        };
    },
    methods: {
        handleClick(k) {
            this.createdItem = [...new Set([...this.createdItem, k])];
            this.activeIndex = k;
            this.$emit("update:activeIndexProp", this.activeIndex);
        },
    },
    watch: {
        activeIndexProp(newValue) {
            this.activeIndex = newValue;
        }
    },
    created() {
        this.activeIndex = this.activeIndexProp;
        this.createdItem = [this.activeIndex];
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/index.less";
.l5lt9c0o {
    .wsnw;
    .flg;
    .df;
    overflow: auto;
}
.l5ixubw6 {
    .dib;
    .cp;
    background: #f8f8f8;
    padding: 9px 18px;
    &.active {
        background: @c-theme;
        color: #fff;
        border-radius: 3px;
    }
    &:not(:last-child) {
        .mr10;
    }
}
.l5szz1m4 {
    padding-top: 1px;
}
.l79vjd40 {
    .df;
    .aic;
    box-shadow: 0 1px 0 0 @c-theme;
}
</style>
<style lang="less">
@import (reference) "@/assets/less/index.less";
// 移动端
@media screen and (max-width: 750px) {
    .l5lt9c0o {
        .wsnw;
        overflow: auto;
    }
}
</style>
